import React from 'react'
import classnames from 'classnames'
import formatMessage from 'format-message'
import Point from './Point'
import Annotation from './Annotation'
import { saveCommentFn } from './utils.js'
import SecondaryControls from '../SecondaryControls'
import SelectionBox from './SelectionBox'
import { DEFAULT_POINT_ANNOTATION_COLOR } from '../constants'

import './PointAnnotation.css'

export default function PointAnnotation(props) {
  const {
    annotation,
    canEdit,
    commentReplies,
    isHovered,
    isSelected,
    onCreateAnnotation,
    onCurrentColorChange,
    onUpdateAnnotation,
    selectionBoxPadding,
    sessionUserObject,
    viewportHeight,
    viewportScale,
  } = props

  const updateColor = (color) => {
    onUpdateAnnotation(viewportHeight, viewportScale, { ...annotation, color })
    onCurrentColorChange(color, 'point')
  }

  const handleCommentSave = saveCommentFn({
    annotation,
    commentReplies,
    onUpdateAnnotation,
    viewportHeight,
    viewportScale,
    onCreateAnnotation,
    sessionUserObject,
  })

  const [[x1, y1], [x2, y2]] = annotation.rect
  const width = x2 - x1
  const height = y1 - y2

  const secondaryControls = (
    <SecondaryControls
      controlMode="point"
      currentColor={annotation.color}
      onCurrentColorChange={updateColor}
    />
  )

  const isVisible = isHovered || isSelected

  const classes = classnames('PointAnnotation', {
    'PointAnnotation--editable': canEdit,
  })

  return (
    <Annotation
      {...props}
      className={classes}
      iconColor={annotation.color ? annotation.color : DEFAULT_POINT_ANNOTATION_COLOR}
      height={height}
      id={annotation.id}
      isMovable={true}
      onCommentSave={handleCommentSave}
      selectionBoxPadding={selectionBoxPadding}
      title={formatMessage('Point annotation')}
      width={width}
      x={x1}
      y={y2}
      render={(_isSvgContainerFocused) => [
        <SelectionBox
          height={height + selectionBoxPadding * 2}
          isSelected={isSelected}
          isVisible={isVisible}
          key="selectionbox"
          width={width + selectionBoxPadding * 2}
        />,
        typeof annotation.icon === 'string' && (
          <Point
            color={annotation.color ? annotation.color : DEFAULT_POINT_ANNOTATION_COLOR}
            height={height}
            key="pointIcon"
            width={width}
            x={selectionBoxPadding}
            y={selectionBoxPadding}
          />
        ),
      ]}
      secondaryControls={secondaryControls}
    />
  )
}
